export default __webpack_public_path__ + "static/media/icons.a229bafd.svg";